export default __webpack_public_path__ + "static/media/caret.8a371d09.svg";